﻿window.xmlexport = function () {
    var collections = {};
    var instance = {
        init: function (state) {

        },
        widgetDidMount: function (state) {

            const rootelement = document.getElementById(state.root);

            if (state.state){
                collections[state.root] = state.state.dropDown;

                rootelement.addEventListener('change', function (e) {
                    updateValue(e, collections[e.currentTarget.id]);
                }); 
            }
            

        },
        clearAndSubmit: function (e, widget,validation) {
            if (document.getElementById(widget.toLowerCase())){
                document.getElementById(widget.toLowerCase()).innerHTML = ""
            }
            if (document.getElementById(validation.toLowerCase())){
                document.getElementById(validation.toLowerCase()).innerHTML = ""
            }
            ajaxUtils.postEventFromElementWithApiResponse(e);
        },
        lockProfileOnTab: function (state) {
            var tabs = document.getElementById(state.tabsId);
            if (!tabs || !document.getElementById(state.profileId)) return;

            var apply = function (tabId) {
                // элемент ищется при каждом применении: поле «Профиль» перерисовывается
                // сервером (RefreshDefaultFields), и ссылка на прежний узел становится битой
                var profile = document.getElementById(state.profileId);
                if (!profile) return;

                var locked = tabId === state.lockedTabId;
                // блокируем визуально, значение поля должно продолжать отправляться на сервер
                profile.style.pointerEvents = locked ? 'none' : '';
                profile.style.background = locked ? '#eeeeee' : '';
                profile.style.color = locked ? '#888888' : '';
                profile.setAttribute('tabindex', locked ? '-1' : '0');
            };

            // действие вызывается повторно после перерисовки поля «Профиль»,
            // поэтому обработчики клика навешиваются только один раз на контейнер вкладок,
            // а состояние блокировки применяется при каждом вызове
            if (tabs.getAttribute('data-lockprofile') !== state.profileId) {
                tabs.setAttribute('data-lockprofile', state.profileId);

                var labels = tabs.querySelectorAll('label[data-id]');
                for (var i = 0; i < labels.length; i++) {
                    labels[i].addEventListener('click', function (e) {
                        apply(e.currentTarget.getAttribute('data-id'));
                    });
                }
            }

            var checked = tabs.querySelector('input[type=radio]:checked');
            if (checked) {
                var label = tabs.querySelector('label[for="' + checked.id + '"]');
                apply(label ? label.getAttribute('data-id') : null);
            }
        }
    };

    function updateValue(e, collection) {

        var key = e.target.value + e.target.className;

        var newcollection = collection[key];

        var item = document.getElementById(e.target.className.toLowerCase());
        var length = item.options.length
        for (var i = 0; i < length; i++) {
            item.options.remove(0);
        }

        for (var i = 0; i < newcollection.length; i++) {

            var option = document.createElement("option");
            option.text = newcollection[i].text;
            option.value = newcollection[i].value;
            item.options.add(option);

        }

        //document.getElementById('xmlexport_atsareaid').textContent = 

    }

    return instance;
}();